<template>
    <div>
    <Header></Header>
    <Login></Login>
    <div class="productIntro-list">
        <div class="productIntro-list-item" v-for="(item,index) in productIntroList" :key="index">
            <div class="product-item-info" :style="{background:'url('+item.productIntroItemBg+') 0% 0% / 100% 100%'}">
                <div class="productIntro-item-info-wrapper">
                  <div>
                    <div class="productIntro-item-title">{{item.productIntroItemTitle}}</div>
                    <div class="productIntro-item-title-content">RAS房地产价格跟踪系统基于澜思内部的楼盘数据库、案例数据库，一方面运用房地产估价师普遍采用的房地产评估理论与方法，一方面结合房地产市场的实际状况， 从而形成澜思自己的算法模型。
                      <span>我们目前可实现即时评估、批量评估、宏观研判等</span>，希望模拟出较为真实的价格环境，为房地产相关企业分析决策提供—定程度的参考。
                    </div>
                  </div>
                  <div class="productIntro-item-img"><img src="../assets/images/productIntro/ras-bg@2x.png" /></div>
                </div>
            </div>
            <div class="product-advantage">
                <div class="product-advantage-title">产品优势</div>
                <div class="product-advantage-enTitle">Product Advantages</div> 
                <div class="product-advantage-list">
                    <div class="product-advantage-list-item" v-for="(v,i) in item.productAdvantageList" :key="i">
                        <div class="product-advantage-list-item-wrapper">
                            <div class="product-advantage-img">
                                <img :src="v.productAdvantageIcon" alt="">
                            </div>
                            <div class="text">{{v.productAdvantageTitle}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="product-function">
                <div class="product-function-title">产品主要功能</div>
                <div class="product-function-enTitle">The Main Function of The Product</div>
                <div class="product-function-list">
                    <div class="product-function-item" v-for="(vv,ii) in item.productFunctionList" :key="ii">
                        <div class="product-function-item-left">
                            <img :src="vv.productFunctionImgUrl" alt="">
                        </div>
                        <div class="product-function-item-right">
                            <div class="product-function-item-title">{{vv.productFunctionText}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="customer-case">
                <div class="customer-case-title">客户案例</div>
                <div class="customer-case-enTitle">Customer Case</div>
                <div class="customer-case-content" :style="{background:'url('+item.customerCaseBgUrl+') 0% 0% / 100% 100%'}">
                   <div class="customer-case-content-wrapper">
                      <div class="customer-case-content-title">{{item.customerCaseContentTitle}}</div>
                      <div class="customer-case-content-text txet">{{item.customerCaseContentText}}</div>
                   </div>
                </div>
            </div>
        </div>
    </div>
    <Footer></Footer>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Login from "@/components/Login.vue";
export default {
  name: "productIntro",
  components: {
    Header,
    Footer,
    Login
  },
  data() {
    return {
      pageIndex: "",
      productIntroList: [
        {
          id: 0,
          productIntroItemBg: require("../assets/images/productIntro/banner-bg@2x.png"),
          productIntroItemTitle: "RAS房地产价格跟踪系统",
          // productIntroItemContent:
          //   "RAS房地产价格跟踪系统基于澜思内部的楼盘数据库、案例数据库，一方面运用房地产估价师普遍采用的房地产评估理论与方法，一方面结合房地产市场的实际状况， 从而形成澜思自己的算法模型。",
          productAdvantageList: [
            {
              productAdvantageIcon: require("../assets/images/productIntro/icon_pipei.png"),
              productAdvantageTitle: "高可用地址匹配"
            },
            {
              productAdvantageIcon: require("../assets/images/productIntro/icon_zhunque.png"),
              productAdvantageTitle: "房价准确度高"
            },
            {
              productAdvantageIcon: require("../assets/images/productIntro/icon_suanfa.png"),
              productAdvantageTitle: "系统开发&算法定制"
            }
          ],
          productFunctionList: [
            {
              productFunctionImgUrl: require("../assets/images/productIntro/主要功能-ras@2x.png"),
              productFunctionText: "房产估价、房价指数、电子估价报告"
            }
          ],
          customerCaseBgUrl: require("../assets/images/productIntro/ras_bg@2x.png"),
          customerCaseContentTitle: "科东估价系统",
          customerCaseContentText:
            "科东估价与银行抵押贷款业务中， 从贷前预估到贷后批量复估，向电子化估价发展；澜城数据结合楼盘架构、案例数据，运用市场比较法模型，实现一房一价估价，代开发科东估价系统"
        }
      ]
    };
  },
  methods: {},
  created() {}
};
</script>

<style lang="less" scoped>
@import "../assets/css/productIntro.less";

.text {
  width: 192px;
  margin-left: 32px;
  height: 64px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #272727;
  line-height: 64px;
}
</style>


